export default function() {
  var nodes = [];
  this.each(function(node) {
    nodes.push(node);
  });
  return nodes;
}



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/d3-hierarchy/src/hierarchy/descendants.js
// module id = 173
// module chunks = 0